//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions } from 'vuex';
import UiSnackbar from './KeenUiSnackbar';

/* Snackbars are used to display notification. */
export default {
  name: 'CoreSnackbar',
  components: {
    UiSnackbar,
  },
  props: {
    /* Text of notification to be displayed */
    text: {
      type: String,
      required: true,
    },
    /* To provide an action button, provide text */
    actionText: {
      type: String,
      required: false,
    },
    /* Automatically dismiss the snackbar */
    autoDismiss: {
      type: Boolean,
      default: false,
    },
    /* Duration that the snackbar is visible before it is automatically dismissed */
    duration: {
      type: Number,
      default: 4000,
    },
    /* Show a backdrop to prevent interaction with the page */
    backdrop: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    timeout: null,
    isVisible: false,
    previouslyFocusedElement: null,
  }),
  mounted() {
    this.isVisible = true;
    if (this.autoDismiss) {
      this.timeout = window.setTimeout(this.hideSnackbar, this.duration);
    }
    if (this.backdrop) {
      window.addEventListener('focus', this.containFocus, true);
      this.previouslyFocusedElement = document.activeElement;
      this.previouslyFocusedElement.blur();
    }
  },
  beforeDestroy() {
    this.isVisible = false;
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
    if (this.backdrop) {
      window.removeEventListener('focus', this.containFocus, true);
      this.previouslyFocusedElement.focus();
    }
  },
  methods: {
    ...mapActions(['clearSnackbar']),
    hideSnackbar() {
      this.$emit('hide');
      this.clearSnackbar();
    },
    containFocus(event) {
      if (event.target === window) {
        return;
      }
      if (!this.$refs.snackbar.$el.contains(event.target)) {
        this.$refs.snackbar.$el.focus();
      }
    },
  },
};

